import { BaseModuleState } from "./_BaseModuleState";

export class CommunicationModuleState extends BaseModuleState {

}
